import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Separator } from "./ui/separator";
import { peso, fmtDateTime } from "../lib/api";

export default function ReceiptDialog({ sale, open, onOpenChange }) {
  if (!sale) return null;
  const bir = sale.bir_snapshot;
  const status = sale.status || "PAID";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="pos-receipt-modal">
        <DialogHeader>
          <DialogTitle className="font-heading">Receipt</DialogTitle>
        </DialogHeader>
        <div className="font-mono text-xs space-y-3 relative">
          {status !== "PAID" && (
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className="text-4xl font-bold text-red-600/20 rotate-[-20deg] border-4 border-red-600/20 rounded px-4 py-1">{status}</span>
            </div>
          )}
          <div className="text-center space-y-0.5">
            {bir ? (
              <>
                <p className="font-bold text-sm">{bir.trade_name || bir.registered_name}</p>
                {bir.registered_name && bir.trade_name && <p className="text-slate-500">{bir.registered_name}</p>}
                {bir.business_address && <p className="text-slate-500">{bir.business_address}</p>}
                {bir.tin && <p className="text-slate-500">TIN: {bir.tin}{bir.branch_code ? `-${bir.branch_code}` : ""}</p>}
                <p className="font-bold mt-1">{bir.invoice_type === "non_vat_invoice" ? "NON-VAT INVOICE" : "VAT INVOICE"}</p>
              </>
            ) : (
              sale.bir_compliant && <p className="font-bold text-sm">OFFICIAL RECEIPT</p>
            )}
            <p className="text-slate-500">{sale.invoice_number}</p>
            <p className="text-slate-500">{fmtDateTime(sale.created_at)}</p>
            <p className="text-slate-500">Cashier: {sale.cashier_name}</p>
          </div>
          {sale.buyer?.name && (
            <>
              <Separator />
              <div className="space-y-0.5 text-slate-600">
                <p className="font-semibold text-slate-800">Buyer: {sale.buyer.name}</p>
                {sale.buyer.tin && <p>TIN: {sale.buyer.tin}</p>}
                {sale.buyer.address && <p>{sale.buyer.address}</p>}
                {sale.buyer.business_name && <p>{sale.buyer.business_name}</p>}
              </div>
            </>
          )}
          <Separator />
          <div className="space-y-1">
            {sale.items.map((it) => (
              <div key={it.sale_item_id} className="flex justify-between gap-2">
                <span className="truncate">{it.quantity}× {it.name}</span>
                <span className="shrink-0">{peso(it.subtotal)}</span>
              </div>
            ))}
          </div>
          <Separator />
          <div className="space-y-1">
            <div className="flex justify-between"><span>Subtotal</span><span>{peso(sale.subtotal)}</span></div>
            {sale.discount_amount > 0 && (
              <div className="flex justify-between text-slate-500">
                <span>Discount{sale.discount_type === "percent" ? ` (${sale.discount_value}%)` : ""}</span>
                <span>-{peso(sale.discount_amount)}</span>
              </div>
            )}
            {sale.bir_compliant && (
              <>
                {sale.vatable_sales > 0 && <div className="flex justify-between text-slate-500"><span>VATable Sales</span><span>{peso(sale.vatable_sales)}</span></div>}
                {sale.tax_amount > 0 && <div className="flex justify-between text-slate-500"><span>VAT</span><span>{peso(sale.tax_amount)}</span></div>}
                {sale.vat_exempt_sales > 0 && <div className="flex justify-between text-slate-500"><span>VAT-Exempt Sales</span><span>{peso(sale.vat_exempt_sales)}</span></div>}
                {sale.zero_rated_sales > 0 && <div className="flex justify-between text-slate-500"><span>Zero-Rated Sales</span><span>{peso(sale.zero_rated_sales)}</span></div>}
                {sale.senior_discount > 0 && (
                  <div className="flex justify-between text-slate-500"><span>Senior/PWD Discount</span><span>-{peso(sale.senior_discount)}</span></div>
                )}
              </>
            )}
            <div className="flex justify-between font-bold text-sm pt-1"><span>TOTAL</span><span>{peso(sale.total_amount)}</span></div>
            <div className="flex justify-between text-slate-500 capitalize">
              <span>{sale.payment_method}{sale.payment_mode ? ` (${sale.payment_mode})` : ""}</span>
              <span>{sale.tendered ? peso(sale.tendered) : ""}</span>
            </div>
            {sale.payment_ref && <div className="flex justify-between text-slate-500"><span>Ref</span><span>{sale.payment_ref}</span></div>}
            {sale.change != null && sale.change > 0 && (
              <div className="flex justify-between text-slate-500"><span>Change</span><span>{peso(sale.change)}</span></div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
